/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const divorcePlannerStyle = {
  navigationPaper: {
    display: "block",
    textDecoration: "none",
    padding: "1rem",
  },
  imageCircle: {
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    width: "70px",
    height: "70px",
    padding: "18px",
    borderRadius: "50% !important",
    "& > img": {
      maxHeight: "40px",
    },
    border: "1px solid #333",
  },
  contentName: {
    fontSize: "1.125rem",
    color: "text.primary",
    fontWeight: 400,
  },
  processContainer: {
    padding: "1.5rem",
    typography: "body2",
  },
  contentContainer: {
    padding: "1.5rem",
    typography: "body2",
  },
  headlineContainer: {
    marginBottom: "1rem",
    marginLeft: "-0.5rem",
  },
  headlineContent: {
    alignItems: "center",
    columnGap: "1rem",
  },
  checklist: {
    marginTop: "2rem",
    borderTop: "1px solid #ccc",
    paddingTop: "2rem",
  },
  checklistHeader: {
    textAlign: "left",
  },
  checklistContainer: {
    marginLeft: "0.5rem",
  },
  primary: {
    color: "primary.main",
  },
};

export default divorcePlannerStyle;
